<section class="hardware-details">
  <app-accessory-information
    [imageUrl]="accessoryItem.image ? accessoryItem.image.previewUri : (selectedTheme$ | async).accessories_illustration"
    [keyInformation]="accessoryItem.keyInformation"
    [manufacturer]="accessoryItem.manufacturer"
    [name]="accessoryItem.name"
    [webShopLink]="webShopLink"
  />
  <div class="payment-section">
    <div class="accessory-information">
      @if (!isAccessoryBindingAvailable) {
        <span class="price-info">
          {{ accessoryItem.priceInformation.price.includingVAT | priceFormat: PriceType.OneTime }}
        </span>
      }
      <span class="stock-info">
        @if (quantityInStock) {
          <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
          <span>{{ quantityInStock }} på lager</span>
        } @else if (canBeBackOrdered) {
          <mat-icon [svgIcon]="IconNames.ice_clock" />
          <span>{{ accessoryItem.backorderInfo.text }}</span>
        } @else {
          Ingen på lager
        }
      </span>
    </div>
    @if (isAccessoryBindingAvailable) {
      <form [formGroup]="accessoryForm">
        <div class="label">Betalingsmetode</div>
        <mat-radio-group formControlName="paymentMethod">
          <app-subscription-chooser
            [accessoryItem]="accessoryItem"
            [availableSubscriptions]="availableSubscriptions"
            [form]="accessoryForm"
            [selectedSubscription]="selectedSubscription"
            (subscriptionChange)="onSubscriptionChange()"
          />
        </mat-radio-group>
        @if (accessoryForm.get('paymentMethod').value === PaymentMethod.PayWithSubscription) {
          <app-phone-number-options
            [existingVoiceProducts]="existingVoiceProducts()"
            [form]="accessoryForm"
            [selectedSubscription]="selectedSubscription"
          />
        }
      </form>
      <div class="buttons">
        <app-ice-button color="secondary" testId="back-to-equipment-button" width="100%" (click)="backToSearch.emit()">
          Tilbake til tilbehør
        </app-ice-button>
        <app-ice-button
          color="primary"
          testId="add-equipment-to-cart-button"
          width="100%"
          [disabled]="accessoryForm.invalid || isOutOfStock"
          [tooltip]="isOutOfStock ? 'Ikke på lager' : ''"
          (click)="onConfirm()"
        >
          Fortsett
        </app-ice-button>
      </div>
    } @else {
      <div class="buttons">
        <app-ice-button color="secondary" testId="back-to-equipment-button" width="100%" (click)="backToSearch.emit()">
          Tilbake til tilbehør
        </app-ice-button>
        <app-ice-button
          color="primary"
          testId="add-equipment-to-cart-button"
          width="100%"
          [disabled]="isOutOfStock"
          [tooltip]="isOutOfStock ? 'Ikke på lager' : ''"
          (click)="onConfirm()"
        >
          Legg til i handlekurv
        </app-ice-button>
      </div>
    }
  </div>
</section>

<ng-template #showLoading>
  <app-spinner align="right" />
</ng-template>
